import SubscriptionErrorMessage from './SubscriptionErrorMessage'

export default SubscriptionErrorMessage
// eslint-disable-next-line import/export
export * from './SubscriptionErrorMessage'
